import React, { FC } from 'react'
import { Card } from 'transfix-ui/components/Card'
import { Box, createStyles, makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks/useFMSAnalytics'
import { OfferedShipment } from 'apps/fleet-planner/types/apiTypes'
import { OfferRow } from './OfferRow'
import { OfferRowMobile } from './OfferRowMobile'

type TOfferRowContainerClassKey = 'row'
interface IUseOfferRowContainerStyleProps {
  isHomePage: boolean
  isClickable: boolean
}

const useOfferRowContainerStyles = makeStyles(theme =>
  createStyles<TOfferRowContainerClassKey, IUseOfferRowContainerStyleProps>({
    row: {
      '&:hover, &:focus': {
        backgroundColor: props => (props.isClickable ? brandColors.coolGray1 : 'none'),
      },
      padding: theme.spacing(2),
      border: props => (props.isHomePage ? `1px solid ${brandColors.coolGray2}` : ''),
      cursor: props => (props.isClickable ? 'pointer' : ''),
    },
  })
)
interface IOfferRowContainerProps {
  shipmentOffer: OfferedShipment
  variant: 'home' | 'offer'
  isOfferUnavailable?: boolean
  onClick: (id: string) => void
  onDeclineHandler: (response: string) => void
  isClickable?: boolean
}

export const OfferRowContainer: FC<IOfferRowContainerProps> = ({
  isClickable: isClickableProp = true,
  isOfferUnavailable,
  onClick,
  onDeclineHandler,
  shipmentOffer,
  variant,
}) => {
  const { isMobile } = useBreakpointContext()
  const { trackEvent } = useFMSAnalytics()
  const { externalId, offeredState } = shipmentOffer || {}
  const isClickable = isClickableProp && offeredState !== 'dedicated_rate_offered_to_more_carriers'

  const classes = useOfferRowContainerStyles({
    isHomePage: variant === 'home',
    isClickable,
  })

  const offerClickHandler = () => {
    if (externalId && isClickable) {
      trackEvent(
        'Offers',
        variant === 'home' ? 'CLICKED_OFFER_ROW_IN_HOME_PAGE' : 'CLICKED_OFFER_ROW_IN_OFFER_PAGE',
        { offeredState }
      )
      onClick(externalId.toString())
    }
  }
  if (isMobile) {
    return variant === 'home' ? (
      <Box onClick={offerClickHandler} className={classes.row}>
        <OfferRowMobile
          variant={variant}
          isOfferUnavailable={isOfferUnavailable}
          shipmentOffer={shipmentOffer}
          onDeclineHandler={onDeclineHandler}
        />
      </Box>
    ) : (
      <Box onClick={offerClickHandler}>
        <Card className={classes.row}>
          <OfferRowMobile
            variant={variant}
            isOfferUnavailable={isOfferUnavailable}
            shipmentOffer={shipmentOffer}
            onDeclineHandler={onDeclineHandler}
          />
        </Card>
      </Box>
    )
  }
  return variant === 'home' ? (
    <Box onClick={offerClickHandler} className={classes.row}>
      <OfferRow
        variant={variant}
        isOfferUnavailable={isOfferUnavailable}
        shipmentOffer={shipmentOffer}
        onDeclineHandler={onDeclineHandler}
      />
    </Box>
  ) : (
    <Box onClick={offerClickHandler}>
      <Card className={classes.row}>
        <OfferRow
          variant={variant}
          isOfferUnavailable={isOfferUnavailable}
          shipmentOffer={shipmentOffer}
          onDeclineHandler={onDeclineHandler}
        />
      </Card>
    </Box>
  )
}
